// ============================================================
//  src/footer.js — Modales de footer
//
//  - Modal "Enviar sugerencia" → genera mailto: a cx4dpg@gmail.com
//  - Modal "Acerca de"        → info de la aplicación
// ============================================================

import { mostrarToast } from './ui.js';
import { t }           from './i18n.js';

const MAIL_DESTINO = 'cx4dpg@gmail.com';

// ============================================================
//  Modal: Enviar sugerencia
// ============================================================

export function abrirModalSugerencia() {
    limpiarFormSugerencia();
    document.getElementById('modal-sugerencia')
        ?.classList.add('modal--visible');
    setTimeout(() => document.getElementById('campo-texto-sugerencia')?.focus(), 50);
}

export function cerrarModalSugerencia() {
    document.getElementById('modal-sugerencia')
        ?.classList.remove('modal--visible');
    limpiarFormSugerencia();
}

/**
 * Valida el formulario y abre el cliente de mail del usuario
 * con el asunto y cuerpo precargados.
 * @param {Event} evento
 */
export function manejarEnviarSugerencia(evento) {
    evento.preventDefault();

    const tipo  = document.getElementById('campo-tipo-sugerencia')?.value ?? 'Sugerencia';
    const texto = document.getElementById('campo-texto-sugerencia')?.value.trim() ?? '';
    const errorEl = document.getElementById('error-sugerencia');

    // Validación mínima
    if (!texto) {
        if (errorEl) {
            errorEl.textContent = t('sugerencia.error.vacio');
            errorEl.classList.add('visible');
        }
        document.getElementById('campo-texto-sugerencia')?.focus();
        return;
    }

    // Limpiar error si había
    if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('visible');
    }

    // Construir mailto:
    const asunto  = encodeURIComponent(`[Contest Manager] ${tipo}`);
    const cuerpo  = encodeURIComponent(
        `Tipo: ${tipo}\n\n${texto}\n\n---\nEnviado desde Contest Manager v2.0.0-beta`
    );
    const mailtoUrl = `mailto:${MAIL_DESTINO}?subject=${asunto}&body=${cuerpo}`;

    // Abrir cliente de mail
    window.location.href = mailtoUrl;

    cerrarModalSugerencia();
    mostrarToast(t('sugerencia.toast.abriendo'), 'info', 3000);
}

function limpiarFormSugerencia() {
    const campo = document.getElementById('campo-texto-sugerencia');
    if (campo) campo.value = '';

    const tipo = document.getElementById('campo-tipo-sugerencia');
    if (tipo) tipo.value = 'Sugerencia';

    const errorEl = document.getElementById('error-sugerencia');
    if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('visible');
    }
}

// ============================================================
//  Modal: Acerca de
// ============================================================

export function abrirModalAcercaDe() {
    document.getElementById('modal-acerca-de')
        ?.classList.add('modal--visible');
}

export function cerrarModalAcercaDe() {
    document.getElementById('modal-acerca-de')
        ?.classList.remove('modal--visible');
}
